<div class="flex flex-col w-full justify-center items-center">
  <ng-container [ngTemplateOutlet]="isLoad ? load : error"></ng-container>
</div>

<ng-template #load>
  <mat-spinner></mat-spinner>
</ng-template>
<ng-template #error>
  <button mat-raised-button color="primary" (click)="onReload()">Pefresh</button>
</ng-template>